<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import appConfig from "@/app.config.json";
import useVuelidate from "@vuelidate/core";
import DropZone from "@/components/widgets/dropZone.vue";
import {helpers, required} from "@vuelidate/validators";
import Loader from "../components/loader.vue";
import api from "@/axios";
import moment from "moment";
import Swal from "sweetalert2";
import {ref} from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Movimento de Ajuste de Estoque",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect, DropZone },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    const selectedFile = () => {
      dropzoneFile.value = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

      let arquivo = document.querySelector(".dropzoneFile").files[0]
      console.log(arquivo)

    };
    return { dropzoneFile, drop, selectedFile, v$: useVuelidate() };
  },
  data() {
    return {
      wmsenderecoPadrao: '',
      showModalEndereco: false,
      submitOrctoItem: false,

      loadingFornec: false,
      loadingCondPgto: false,
      loadingFormaPgto: false,
      loadingPedTipo: false,
      loadingMovAjtItem: false,

      dtListPesqFor: null,
      dtListPesqCondPgto: null,
      dtListPesqFormaPgto: null,
      dtlistPesqPedTipo: null,
      dtlistPesqMovAjtItem: null,

      showModalFornecedor: false,
      showModalCondPgto: false,
      showModalFormaPgto: false,
      showModalPedTipo: false,
      showModalMovAjtItem: false,
      showModalObs: false,
      showModalImpXML: false,

      movAjtData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        origem: '',
        tipo: null,
        dtemissao: new Date,
        desconto: 0.00,
        valorliq: 0.00,
        empresa: null
      },
      fornecedorData: null,
      condPgtoData: {
        'codigo': '10',
        'descricao': '30 / 60 Dias'
      },
      formaPgtoData: {
        'codigo': '10',
        'descricao': 'Boleto'
      },
      pedTipoData: {
        'codigo': '01',
        'descricao': 'Ajuste de Estoque - Entrada'
      },
      movAjtItemData: {},
      movAjtItensData: [],

      somaPedidosFor: 0,
      ultPedsData: null,
      errosValid: null,

      idData: 0,
      updating: true,
      title: "Editar Movimento de Ajuste",
      items: [
        {
          text: "Movimentos",
          href: "/movajustes/list",
        },
        {
          text: "Editar Movimento de Ajuste",
          active: true,
        },
      ],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },

      dtlistPesqEndereco: null,
      showModalLote: false,
      movajtitemedit: {},

      showModalErros: false,
      dtListErrors: [],
      dtListPesqEmpresa: [],
      empresaData: null
    };
  },
  validations: {
    movAjtItemData: {
      produto: {
        required: helpers.withMessage("Campo produto obrigatório, favor preencher.", required),
      },
      qtd: {
        required: helpers.withMessage("Campo quantidade obrigatório, favor preencher.", required),
      },
      vlrunitliq: {
        required: helpers.withMessage("Campo valor unitário obrigatório, favor preencher.", required),
      },
      vlrtotalliq: {
        required: helpers.withMessage("Campo valor total obrigatório, favor preencher.", required),
      },
    }
  },
  watch: {
    'movAjtItemData.qtd': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movAjtItemData.vlrunitliq': {
      handler() {
        this.calculaTotalItem()
      }
    },
  },
  mounted() {
    console.log('mounted_movajt_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0){
      this.carregarDados()
    }else{
      this.title = `Criando Novo Ajuste de Estoque`
      this.updating = false
    }
  },

  methods:{
    removerCodAjuste(){
      this.movAjtData.codigo = null
      this.salvar()
    },

    pesqEmpresa(evt){
      console.log('pesqEmpresa')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/emprepesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(JSON.stringify(res.data))

          this.dtListPesqEmpresa = res.data
        })
      }
    },

    cancelaNovoAjt() {
      this.showModalErros = false
      this.carregarDados()
    },

    criarNovoMovAjt() {
      console.log('criarNovoMovAjt')

      //criamovajtreman

      api.post(`${getBaseUrl()}api/criamovajtreman`, {
        'movajtitens': this.dtListErrors,
        'iddata': this.idData
      }).then((res) => {
        console.log('then axios criamovajtreman')
        console.log(res.data)

        if(res.data.success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            let route = this.$router.resolve({ name: "MovAjtEditar", params: { id: res.data.id } });
            window.open(route.href, '_self');
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.error,
            showConfirmButton: false,
            timer: 3500
          }).then(() => {
            this.carregarDados()
          })
        }
      })
    },

    confirmaAssocLote(){
      this.movAjtItensData.forEach(item => {
        if (this.movajtitemedit.produto_id === item.produto_id && this.movajtitemedit.id === item.id) {
          item.lote = this.movajtitemedit.lote
          item.endwms = this.movajtitemedit.endwms
        }
      })
      this.showModalLote = false


      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Salve antes de confirmar!",
        showConfirmButton: false,
        timer: 1000
      })
    },

    associaLote(item) {
      //console.log(JSON.stringify(item))

      if (this.movAjtData.status !== 'EL'){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
        return
      }
      
      this.movajtitemedit = item
      this.showModalLote = true
    },

    pesqEndereco(evt) {
      console.log('pesqEndereco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        // this.loadingPedTipo = true
        // this.wmsOsItemSepData.endwms = ''
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "movajt", origem_id: this.movAjtData.id }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqEndereco = res.data
        })
      }
    },

    escolheuEndereco() {
      console.log('escolheuEndereco')
    },


    confirmarXML(){
      console.log('confirmarXML')
      this.showModalImpXML = false
      this.$router.replace({
        path: `/nota/editar/0`,
        params: this.selectedFile
      })
    },

    importarXML(){
      // console.log('importarXML')
      // this.showModalImpXML = true

      this.$router.replace({
        path: `/nota/editar/0`
      })

    },


    copiar(){
      console.log('copiar')
      this.updating = true
      api.post(`${getBaseUrl()}api/movajtcopy`, {
          'iddata': this.idData
      }).then((res) => {
        console.log('then axios copiar')
        console.log(res.data[0].id)
        //this.movAjtData = res.data

        this.idData = res.data[0].id
        this.$router.replace({ path: `/movajuste/editar/${this.idData}` })
        this.carregarDados()

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Movimento copiado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })

    },

    deletarOrctoItem(iditem){
      console.log('deletarOrctoItem')
      console.log(iditem)

      if (this.movAjtData.status === 'EL'){
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Exclusão de Registro",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.updating = true
            api.delete(`${getBaseUrl()}api/movajtitem`, {
              params: {
                'iddata': iditem
              }
            }).then((res) => {
              console.log('then axios delete')
              console.log(res.data)
              this.carregarDados()
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })

          }
        })
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    calculaTotalItem(){
      console.log('calculaTotalItem')

      let quant = this.movAjtItemData.qtd
      let vlrUnit = this.movAjtItemData.vlrunitliq
      let vlrUnitTab = this.movAjtItemData.vlrunitbrt
      let percDesc = 0

      if (quant > 0 && vlrUnit > 0){

        let valorTotalItem = quant * vlrUnit
        console.log('valorTotalItem')
        console.log(valorTotalItem)

        if (vlrUnit !== vlrUnitTab){
          percDesc = (1 - (vlrUnit / vlrUnitTab)) * 100
        }


        this.movAjtItemData.desconto = percDesc
        this.movAjtItemData.vlrtotalbrt = vlrUnitTab * quant
        this.movAjtItemData.vlrtotalliq = valorTotalItem
      }

    },

    confOrctoItem(){
      console.log('confOrctoItem: ' + this.idData)
      this.v$.$touch()
      this.submitOrctoItem = true

      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.movAjtItemData.empresa = this.movAjtData.empresa
        this.loadingMovAjtItem = true

        api.post(`${getBaseUrl()}api/movajtitem`, {
          movAjtItemData: this.movAjtItemData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.produtoData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.loadingMovAjtItem = false
          this.showModalMovAjtItem = false
          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })

      }
    },

    novoProduto(){
      console.log('novoProduto: ' + this.idData)

      if (this.idData === 0){

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar o movimento antes de adicionar item",
          showConfirmButton: false,
          timer: 1500
        })

      }else{
        this.movAjtItemData = {}
        this.showModalMovAjtItem = true
      }


    },

    detalhesProduto(idProd){
      console.log('detalhesProduto: ' + idProd)

      this.$router.push(`/produto/detalhe/${idProd}`);

      // let route = this.$router.resolve({ path: "/contact" });
      // window.open(route.href);


    },

    editarProduto(idProd){
      console.log('editarProduto: ' + idProd)

      if (this.movAjtData.status === 'EL'){
        this.showModalMovAjtItem = true
        this.loadingMovAjtItem = true

        api.get(`${getBaseUrl()}api/movajtitem`, {
          params: { iddata: idProd }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data[0])

          this.movAjtItemData = res.data[0]

          // if (this.movAjtItemData.imgs){
          //   let imgTrat = this.movAjtItemData.imgs.split(',')
          //   this.movAjtItemData.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          // }

          this.loadingMovAjtItem = false
        })
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    validaConfirmacao(){
      console.log('validating data')
      if (!this.movAjtItensData || this.movAjtItensData.length <= 0){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor adicionar produto ao movimento antes de confirmar",
          showConfirmButton: false,
          timer: 1500
        })
      }else{

        if(this.movAjtData.tipo == null || this.movAjtData.tipo === ""){
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Selecione e salve o tipo de operação!",
            timer: 4000
          })
        }else{
          /*
           * Validando lotes
           */
          if(this.movAjtData.tipo === '01') {
            //Validando endereços e lotes
            let validadoEnd = true
            let validadoLote = true
            this.movAjtItensData.forEach(item => {
              if(!item.endwms){
                validadoEnd = false
              }

              if(item.deflote &&!item.lote){
                console.log(`item não contém lote definido`)
                validadoLote = false
              }
            })

            /*
            * Validando Origem
            */
            if(this.movAjtData.origem === "" || this.movAjtData.origem === null){
              Swal.fire({
                position: "center",
                icon: "warning",
                title: "Selecionar Origem do ajuste!",
                showConfirmButton: false,
                timer: 3000
              })

              return
            }

            /*
            * Validando lotes
            */
            if(!validadoLote) {
              Swal.fire({
                position: "center",
                icon: "warning",
                title: "Preenchimento de lotes pendentes!",
                text: "Verifique a lista de itens",
                timer: 2500
              })

              return
            }

            /*
            * Validando endereços
            */
            if(!validadoEnd){
              Swal.fire({
                position: "center",
                icon: "warning",
                title: "Itens sem endereço definido!",
                text: "Abrindo caixa de seleção de endereço padrão",
                timer: 2500
              }).then(() => {
                this.showModalEndereco = true
              })
            }else{
              this.confirmar()
            }
          }else{
            this.confirmar()
          }
        }
      }
    },

    confirmar(){
      console.log('confirmar: ' + this.idData)

      if(this.showModalEndereco){
        this.showModalEndereco = false
      }

      /*
      * Validando se tipo foi definido
      */
      if(this.movAjtData.tipo === null){
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Favor selecionar o tipo de ajuste!",
          showConfirmButton: false,
          timer: 2500
        })

        return
      }

      /*
      * Validando quantidade de itens
      */
      if(this.movAjtItensData.length < 1){
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Ajuste precisa de pelo menos 1 item!",
          showConfirmButton: false,
          timer: 2500
        })

        return
      }

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Confirmação de Movimento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.post(`${getBaseUrl()}api/movajtconf`, {
            iddata: this.idData,
            endwmsPadrao: this.wmsenderecoPadrao
          }).then((res) => {
            console.log('then movajtconf')
            console.log(JSON.stringify(res.data))
            // console.log(res.data)

            this.updating = false
            let resMovAjt = res.data

            if(!resMovAjt.success){
              let errorMessage = res.data.error ?? res.data.message 
              
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: errorMessage ?? "Erro na confirmação do ajuste!",
                timer: 4000
              }).then(() =>{
                this.carregarDados()
              })
            }else{
              if(res.data.errosSaidas.length > 0) {
                this.dtListErrors = res.data.errosSaidas
                this.showModalErros = true
              } else {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Movimento confirmado com sucesso",
                  showConfirmButton: false,
                  timer: 1500
                }).then(() =>{
                  this.carregarDados()
                })
              }
            }
          })
        }
      })
    },

    cancelar(){
      console.log('cancelar: ' + this.idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Movimento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          if (this.idData > 0){
            this.updating = true
            api.post(`${getBaseUrl()}api/movajtcanc`, {
              iddata: this.idData
            }).then((res) => {
              console.log('then axios')
              console.log(res)
              this.movAjtData = res.data[0]
              this.updating = false
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Movimento cancelado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })
          }else{
            this.$router.go(-1)
          }


        }
      })
    },
    nomeStatus(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'EL':
          result = 'Elabotação'
          break
        case 'FA':
          result = 'Faturado'
          break
        case 'CA':
          result = 'Cancelado'
          break
      }
      return result
    },
    alteraObs(){
      console.log('alteraObs')
      if (this.movAjtData.status === 'EL'){
        this.showModalObs = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    carregarDados(){
      api.get(`${getBaseUrl()}api/movajt`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios _carregarDados')
        console.log(res.data)
        //console.log(JSON.stringify(res.data))

        this.movAjtData = res.data[0]
        this.fornecedorData = res.data[1]
        this.pedTipoData = res.data[2]
        this.formaPgtoData = res.data[3]
        this.condPgtoData = res.data[4]
        this.movAjtItensData = res.data[5]
        if(res.data[6]){
          this.empresaData = res.data[6]
        }

        if (this.movAjtItensData && this.movAjtItensData.length > 0){
          this.movAjtItensData.forEach((value) => {
            // let imgTrat = value.imgs.split(',')
            // value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            // console.log(value.vlrtotalliq);
            let valor = parseFloat(value.vlrtotalliq)
            this.valorTotalItens += valor
          });
        }

        this.idData = this.movAjtData.id
        this.title = `Editar Movimento de Ajuste (${this.movAjtData.id}) ${this.fornecedorData != null ? this.fornecedorData.nome : ''}`
        this.updating = false
      });
    },
    selecionaCli(){
      console.log('selecionaCli')
      if (this.movAjtData.status === 'EL'){
        this.showModalFornecedor = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaCondPgto(){
      console.log('selecionaCondPgto')
      if (this.movAjtData.status === 'EL') {
        this.showModalCondPgto = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaFormaPgto(){
      console.log('selecionaFormaPgto')
      if (this.movAjtData.status === 'EL') {
        this.showModalFormaPgto = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaPedTipo(){
      console.log('selecionaPedTipo')
      if (this.movAjtData.status === 'EL') {
        console.log(this.movAjtData.tipo)
        this.showModalPedTipo = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaOrctoItem(){
      console.log('selecionaOrctoItem')
      if (this.movAjtData.status === 'EL') {
        this.showModalMovAjtItem = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarFornec(){
      console.log('confirmarFornec')
      this.showModalFornecedor = false
      this.salvar()
    },
    confirmarCondPgto(){
      console.log('confirmarCondPgto')
      this.showModalCondPgto = false
    },
    confirmarFormaPgto(){
      console.log('confirmarFormaPgto')
      this.showModalFormaPgto = false
    },
    confirmarPedTipo(){
      console.log('confirmarPedTipo')
      this.showModalPedTipo = false

      this.salvar()
    },
    confirmarOrctoItem(){
      console.log('confirmarOrctoItem')
      this.showModalMovAjtItem = false
    },

    pesqFornec(evt){
      console.log('pesqFornec')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqFor = res.data
        });
      }
    },

    pesqCondPgto(evt){
      console.log('pesqCondPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingCondPgto = true
        this.movAjtData.condpgto = ''
        api.get(`${getBaseUrl()}api/cpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCondPgto = res.data
        })
      }
    },

    pesqFormaPgto(evt){
      console.log('pesqFormaPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingFormaPgto = true
        this.movAjtData.formapgto = ''
        api.get(`${getBaseUrl()}api/fpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFormaPgto = res.data
        })
      }
    },

    pesqPedTipo(evt){
      console.log('pesqPedTipo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingPedTipo = true
        this.movAjtData.tipo = ''
        api.get(`${getBaseUrl()}api/tpoprpesq`, {
          params: { q: query, t: 'AJT', f: this.movAjtData.empresa  }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqPedTipo = res.data
        })
      }
    },

    pesqOrctoItem(evt){
      console.log('pesqOrctoItem')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtlistPesqMovAjtItem = null
        this.loadingMovAjtItem = true
        api.get(`${getBaseUrl()}api/prodpesqoutros`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqMovAjtItem = res.data

          // this.dtlistPesqMovAjtItem.forEach((value) => {
          //   let imgTrat = value.imgs.split(',')
          //   value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          // });

        })
      }
    },

    escolheuFor(){
      console.log('escolheuFor')
      this.loadingFornec = true
      console.log(this.movAjtData.origem)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: this.movAjtData.origem }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.fornecedorData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingFornec = false
      })
    },

    escolheuCondPgto(){
      console.log('escolheuCondPgto')
      this.loadingCondPgto = true
      console.log(this.movAjtData.condpgto)
      api.get(`${getBaseUrl()}api/cpgtocod`, {
        params: { coddata: this.movAjtData.condpgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.condPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingCondPgto = false
      })
    },

    escolheuFormaPgto(){
      console.log('escolheuFormaPgto')
      this.loadingFormaPgto = true
      console.log(this.movAjtData.formapgto)
      api.get(`${getBaseUrl()}api/fpgtocod`, {
        params: { coddata: this.movAjtData.formapgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.formaPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingFormaPgto = false
      })
    },

    escolheuPedTipo(){
      console.log('escolheuPedTipo')
      this.loadingPedTipo = true
      console.log(this.movAjtData.tipo)
      api.get(`${getBaseUrl()}api/tpoprcod`, {
        params: { coddata: this.movAjtData.tipo }
      }).then((res) => {
        console.log('then axios_escolheu_ped_tipo')
        console.log(res.data)
        this.pedTipoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingPedTipo = false
      })
    },

    escolheuOrctoItem(){
      console.log('escolheuItem')
      this.loadingMovAjtItem = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.movAjtItemData.produto }
      }).then((res) => {
        console.log('then axios_escolheu_ped_item')
        console.log(res.data)
        this.movAjtItemData = {
          movajt_id: this.idData,
          produto_id: res.data[0]['id'],
          produto: res.data[0]['codigo'],
          descprod: res.data[0]['descricao'],
          und: res.data[0]['unidade'],
          vlrunitliq: res.data[0]['preco'],
          vlrunitbrt: res.data[0]['preco'],
          vlrtotalliq: res.data[0]['preco'],
          vlrtotalbrt: res.data[0]['preco'],
          img1: `${getBaseUrl() + '_IMG'}/peq/${res.data[0]['imgs']}`,
          qtd: 1
        }
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingMovAjtItem = false
      })
    },

    salvar(){
      console.log('salvar')
      if (this.movAjtData.origem && this.movAjtData.origem !== ''){
        console.log('salvar_00')
        this.updating = true

        this.errosValid = []
        api.post(`${getBaseUrl()}api/movajt`, {
          movAjtData: this.movAjtData,
          movAjtItensData: this.movAjtItensData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.movAjtData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            if (this.idData === 0){
              console.log('redirecionar')
              this.$router.replace({ path: `/movajuste/editar/${this.movAjtData.id}` })
              this.idData = this.movAjtData.id
              this.carregarDados()
            } else {
              this.carregarDados()
            }
          })

          

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })



      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar origem antes de salvar o movimento",
          showConfirmButton: false,
          timer: 1500
        })
      }

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      //var date = new Date(value);
      return moment(value, "YYYY-MM-DD").format(format);
    },

  }

};
</script>

<template>
  <Layout>
    <div class="mb-0" v-if="empresaData !== null">
      <h6 class="text-muted">({{`${empresaData.nome ?? ""}-${empresaData.cnpj ?? ""} - Cód. ${empresaData.codigo ?? ""}`}})</h6>
    </div>
    <PageHeader :title="title" :items="items" :status="movAjtData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">
              <b-button variant="outline-primary" class="mx-2" @click="salvar" :disabled="movAjtData.status !== 'EL'" v-if="movAjtData.status === 'EL'">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="importarXML" :disabled="true">
                <i class="bx bx-import font-size-16 align-middle me-2"></i>
                Importar XML
              </b-button>

              <!--<b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="imprimir">
                <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                Imprimir
              </b-button>-->

              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiar">
                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>
                Copiar
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="cancelar" :disabled="movAjtData.status !== 'EL'" v-if="movAjtData.status === 'EL'">
                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novoProduto" :disabled="movAjtData.status !== 'EL'" v-if="movAjtData.status === 'EL'">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Produto
              </b-button>


              <div class="flex-grow-1 align-self-center">
                <div class="col-md-4 mb-2" v-if="idData === 0">
                  <multiselect id="empresaProd"
                               @search-change="pesqEmpresa"
                               v-model="movAjtData.empresa"
                               placeholder="Selecionar Empresa"
                               :options="dtListPesqEmpresa"
                               :searchable="true"
                               track-by="codigo"
                               label="nome"
                               value-prop="codigo">
                    <template #option="slotProps">
                      <div class="row">
                        <div>
                  <span class="text-info">
                    {{ slotProps.option.cnpj }}
                  </span>
                          <span class="mx-4" >
                  </span>
                        </div>
                        <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                        <span class="mx-4">
                </span>
                        <span class="mx-4" >
                </span>
                        <div class="align-items-end text-end align-content-end">Código: {{ slotProps.option.codigo }} </div>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>

              <button
                  class="btn btn-success"
                  @click="validaConfirmacao"
                  :disabled="movAjtData.status !== 'EL' || idData === 0"
                  v-if="movAjtData.status === 'EL' && movAjtItensData">
                <i class="mdi mdi-check-circle me-1 text-end"></i> CONFIRMAR
              </button>
            </div>
          </div>
        </div>
      </div>

      <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
        favor ajustar e tentar novamente.
      </b-alert>

      <div class="col-xl-4">

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="me-3">
                <span
                    v-if="fornecedorData"
                    class="avatar-title rounded-circle"
                    style="max-height: 55px;
                    min-width: 55px;">{{ fornecedorData.codigo }}
                </span>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <div class="text-muted">

                      <a href="javascript: void(0);" v-if="!fornecedorData" @click="selecionaCli">
                        <h5 class="mb-1 text-info">Selecionar origem ...</h5>
                      </a>

                      <a href="javascript: void(0);" v-if="fornecedorData" @click="selecionaCli">
                        <h5 class="mb-1">{{ fornecedorData.codigo }} - {{ fornecedorData.nome }}</h5>
                        <p class="mb-0">{{ fornecedorData.cidade }}, {{ fornecedorData.estado }}</p>
                      </a>

                    </div>
                  </div>

                  <router-link :to="`/cliente/detalhe/${fornecedorData.id}`" class="ms-2" v-if="fornecedorData" target="_blank">
                    Detalhes Origem Movimento
                    <i class="mdi mdi-arrow-right ms-1"></i>
                  </router-link>

                </div>
                <hr />
                <div class="row">
                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Valor Total</p>
                      <h5 class="mb-0">R$ {{ movAjtData.valorliq ?? formatDecimal(movAjtData.valorliq) }}</h5>
                    </div>
                  </div>
                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Peso Total</p>
                      <h5 class="mb-0">{{ movAjtData.peso ?? formatDecimal(movAjtData.peso) }} kg</h5>
                    </div>
                  </div>

                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Data</p>
                      <h5 class="mb-0">{{ formatDate(movAjtData.dtemissao) }} </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="card">
          <div class="card-body">

            <div class="col-4">
              <div>
                <label for="codAjuste" class="text-muted text-truncate mb-2">
                  Código Ajuste
                  <i v-if="movAjtData.status === 'EL' && movAjtData.codigo !== null" variant="outline-danger" style="cursor:pointer" class="bx bx-x font-size-20 align-middle me-2 text-danger mt-1"
                     @click="removerCodAjuste"
                     title="Remover Código Ajuste"></i>
                </label>

                <input
                    @blur="salvar"
                    id="codAjuste"
                    type="text"
                    v-model="movAjtData.codigo"
                    class="form-control"/>
              </div>
            </div>

            <hr>

            <p>Tipo de ajuste</p>
            <div class="d-flex flex-wrap">
              <a href="javascript: void(0);" v-if="!pedTipoData" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2" :class="{'text-danger': !movAjtData.tipo}">{{ movAjtData.tipo ?? 'SELECIONAR TIPO DE AJUSTE' }}</h5>
              </a>

              <a href="javascript: void(0);" v-if="pedTipoData" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ pedTipoData != null ? pedTipoData.descricao : '' }}</h5>
              </a>

              <b-dropdown
                  toggle-class="text-muted font-size-16 p-0"
                  variant="white"
                  right
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
              >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                </template>
                <b-dropdown-item href="#">Visualizar Pedidos</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item href="#">Nova Chave de Desconto</b-dropdown-item>
              </b-dropdown>
            </div>

<!--            <div class="d-flex flex-wrap">-->
<!--              <div>-->

<!--                <a href="javascript: void(0);" v-if="!formaPgtoData" @click="selecionaFormaPgto">-->
<!--                  <p class="text-muted mb-1">{{ movAjtData.formapgto }}</p>-->
<!--                </a>-->
<!--                <a href="javascript: void(0);" v-if="formaPgtoData" @click="selecionaFormaPgto">-->
<!--                  <p class="text-muted mb-1">{{ formaPgtoData != null ? formaPgtoData.descricao : '' }}</p>-->
<!--                </a>-->

<!--                <a href="javascript: void(0);" v-if="condPgtoData" @click="selecionaCondPgto">-->
<!--                  <h4 class="mb-3">{{ condPgtoData != null ? condPgtoData.descricao : '' }}</h4>-->
<!--                </a>-->


<!--                <p class="text-success mb-0">-->
<!--                    <span-->
<!--                    >0,00 % <i class="mdi mdi-arrow-right ms-1"></i-->
<!--                    ></span>-->
<!--                </p>-->
<!--              </div>-->
<!--              <div class="ms-auto align-self-end">-->
<!--                <i class="bx bx-detail display-4 text-light"></i>-->
<!--              </div>-->
<!--            </div>-->

            <hr />

            <div class="d-flex flex-wrap">
              <div>

                <a href="javascript: void(0);" @click="alteraObs">
                  <p class="text-warning mb-0">
                      <span>
                        {{ movAjtData.obs != null ? movAjtData.obs : 'Observações' }}
                        <i class="mdi mdi-chat-alert ms-1"></i>
                      </span>
                  </p>
                </a>

              </div>

            </div>

          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Detalhamento de Valores</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                <tr>
                  <td>Valor Total Bruto</td>
                  <td class="float-end">{{ formatDecimal(movAjtData.valorliq) }}</td>
                </tr>
                <tr>
                  <td>Valor Desconto</td>
                  <td class="float-end"> {{ formatDecimal(movAjtData.desconto) }}</td>
                </tr>
<!--                <tr>-->
<!--                  <td>Frete</td>-->
<!--                  <td class="float-end">0,00</td>-->
<!--                </tr>-->
                <tr>
                  <th>Valor Total Líquido</th>
                  <th class="float-end">{{ formatDecimal(movAjtData.valorliq) }}</th>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- end table-responsive -->
          </div>
        </div>
        <!-- end card -->
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th>Produto(Qtd:{{movAjtItensData.length}})</th>
                  <th>Descrição</th>
                  <th>Lote</th>
                  <th>Endereço</th>
                  <th class="text-end">Valor Unit.(R$)</th>
                  <th class="text-end">Quant.</th>
                  <th class="text-end">Desconto (%)</th>
                  <th class="text-end">Valor Total (R$)</th>
                  <th class="text-end">Ações</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="data in movAjtItensData" :key="data.id">

                  <td>
                    <h5 class="text-muted mb-0">{{ data.produto }} </h5>
                  </td>

                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <a href="javascript: void(0);" class="text-body fw-bold" @click="editarProduto(data.id)">
                        {{ data.descprod.substr(0, 35) }}
                      </a>
                    </h5>
                    <p class="mb-0">
                      Saldo:
                      <span class="fw-medium"> {{ formatInteger(data.id)  }} </span>
                    </p>
                  </td>

                  <td @click="associaLote(data)" style="cursor: pointer;">
                    <div class="d-flex flex-column align-items-center">
                      <h5 class="text-muted mb-0 align-self-start"
                      :class = "{'align-self-center' : !data.lote, 'align-self-start': data.lote }"
                       v-html="data.lote ? data.lote : '<i class=\'bx bx-highlight\' title=\'Adicionar Lote ao item atual\'></i>'"></h5>
                      <i
                        class="mdi mdi-circle font-size-10"
                        :class="{
                          'text-warning': !data.lote && data.deflote,
                          'text-success': data.lote || !data.deflote
                          }"
                      ></i>
                    </div>
                  </td>

                  <td>
                    <h5 class="text-muted mb-0">{{ data.endwms ?? "-" }} </h5>
                  </td>

                  <td class="text-end">{{ formatDecimal(data.vlrunitliq) }}</td>
                  <td class="text-end">{{ formatDecimal(data.qtd) }}</td>

                  <td class="text-end">
                    <span class="badge badge-pill badge-soft-success font-size-11" v-if="data.desconto !== 0.00"
                          :class="data.desconto < 0.00 ? 'badge-soft-success' :
                          data.desconto > 0 ? 'badge-soft-danger' :  ''">
                      {{ formatDecimal(data.desconto)  }}
                    </span>
                  </td>

                  <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>

                  <td class="text-end">

                    <a href="javascript:void(0);"
                       class="action-icon text-success mx-2"
                       @click="detalhesProduto(data.produto_id)">
                      <i class="mdi mdi-eye font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);"
                       v-if="movAjtData.status === 'EL'"
                       class="action-icon text-warning mx-2"
                       @click="editarProduto(data.id)">
                      <i class="mdi mdi-pencil-outline font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);"
                       v-if="movAjtData.status === 'EL'"
                       class="action-icon text-danger mx-2"
                       @click="deletarOrctoItem(data.id)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>



    <b-modal :title="fornecedorData != null ? `Detalhes Origem Movimento (${ fornecedorData.nome })` : 'Detalhes Origem Movimento'" v-model="showModalFornecedor" centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <label for="cidade">Origem</label>

          <multiselect @search-change="pesqFornec"
                       @select="escolheuFor"
                       v-model="movAjtData.origem"
                       placeholder="Pesquisar pessoa origem movimento"
                       :options="dtListPesqFor"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>


      <div class="row" v-if="loadingFornec">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingFornec && fornecedorData">
        <router-link :to="`/cliente/detalhe/${fornecedorData.id}`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ fornecedorData.codigo }} </span>
          </p>
        </router-link>
          <p class="mb-2" >
              Endereço:
              <span> {{ fornecedorData.rua }}, {{ fornecedorData.numero }}, {{ fornecedorData.bairro }}  </span>
              <span> {{ fornecedorData.cidade }} - {{ fornecedorData.estado }} </span>
          </p>
        <p class="mb-4" >
          <span> {{ fornecedorData.tel1 }} / {{ fornecedorData.email }}</span>
        </p>
          <div class="table-responsive">
            <table class="table table-centered table-nowrap">
              <thead>
              <tr>
                <th scope="col">Últimas Movimentos</th>
                <th scope="col" class="text-end">Data</th>
                <th scope="col" class="text-end">Valor (R$)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="data in ultPedsData" :key="data.id">
                <td>
                  <router-link :to="`/movajuste/editar/${data.id}`" target="_blank">
                    <div>
                      <h5 class="text-truncate font-size-14">
                        {{ data.codigo }}
                      </h5>
                    </div>
                  </router-link>
                </td>
                <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
                <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
                </td>
                <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
                </td>
                <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
              </tr>
              </tbody>
            </table>
          </div>

      </div>

      <div>
        <div class="text-start mt-5">
          <router-link  to="/cliente/editar/0" target="_blank">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Cadastrar Nova Pessoa
          </router-link>
        </div>
      </div>

      <div v-if="!loadingFornec && fornecedorData">
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalFornecedor = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFornec">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Detalhes Tipo de operação" v-model="showModalPedTipo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Novo Tipo de Operação</label>

          <multiselect id="tipooperacao"
                       @search-change="pesqPedTipo"
                       @select="escolheuPedTipo"
                       v-model="movAjtData.tipo"
                       placeholder="Pesquisar tipo de operação"
                       :options="dtlistPesqPedTipo"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingPedTipo && pedTipoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ pedTipoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ pedTipoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Movimentos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movajuste/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPedTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarPedTipo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Detalhes Forma de Pagamento" v-model="showModalFormaPgto" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="formapgto">Selecionar Nova Forma de Pagamento</label>

          <multiselect id="formapgto"
                       @search-change="pesqFormaPgto"
                       @select="escolheuFormaPgto"
                       v-model="movAjtData.formapgto"
                       placeholder="Pesquisar forma de pagamento"
                       :options="dtListPesqFormaPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingFormaPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingFormaPgto && formaPgtoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ formaPgtoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ formaPgtoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Movimentos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movajuste/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFormaPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFormaPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



    <b-modal title="Detalhes Condição de Pagamento" v-model="showModalCondPgto" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="condpgto">Selecionar Nova Condição de Pagamento</label>

          <multiselect id="condpgto"
                       @search-change="pesqCondPgto"
                       @select="escolheuCondPgto"
                       v-model="movAjtData.condpgto"
                       placeholder="Pesquisar condição de pagamento"
                       :options="dtListPesqCondPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                <span class="mx-4" >

                </span>
                <span class="mx-4" >

                  </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingCondPgto && condPgtoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ condPgtoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ condPgtoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Movimentos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movajuste/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarCondPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Alterar Observação" v-model="showModalObs" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="observacao">Favor informar as observações</label>
          <textarea
              id="obs"
              v-model="movAjtData.obs"
              type="text"
              rows="3"
              class="form-control"
              placeholder="Observações"/>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalObs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalObs = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal size="lg"
             :title="movAjtItemData.id != null ? `Editar Item da Movimento (${ movAjtItemData.id })` : 'Criar Novo Item no Movimento'"
             v-model="showModalMovAjtItem"
             hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="cidade">Selecionar Novo Produto</label>
          <multiselect @search-change="pesqOrctoItem"
                       @select="escolheuOrctoItem"
                       v-model="movAjtItemData.produto"
                       placeholder="Pesquisar novo produto"
                       :options="dtlistPesqMovAjtItem"
                       :searchable="true"
                       label="descricao"
                       class="multiselect-size"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps" v-if="dtlistPesqMovAjtItem">
              <div class="row" style="min-width: 100%;">

                <div style="min-width: 100%;">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.unidade }}
                  </span>
                  <span class="float-end text-warning" >
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                </div>

                <div class="col-12">
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                  <span class="float-end" >

                  </span>
                </div>

                <div class="align-items-end text-end align-content-end float-end">
                  <div class="avatar-xs">
                    <span class="avatar-title rounded-circle">{{ slotProps.option.id }}</span>
                  </div>


                  <span class="float-end ">
                    <span v-if="slotProps.option.saldo > 0" class="avatar-title rounded-circle bg-success avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                    <span v-else class="avatar-title rounded-circle bg-danger avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                  </span>
                </div>


              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="row" v-if="loadingMovAjtItem">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingMovAjtItem && movAjtItemData && movAjtItemData.descprod">

        <router-link :to="`/produto/detalhe/${movAjtItemData.produto_id}`" target="_blank" >
          <div class="row">

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 160px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <p class="text-muted mb-2">{{ movAjtItemData.descprod }}</p>
                      <h5 class="mb-0">saldo: 120 ({{ movAjtItemData.und }})</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-sm ms-auto" v-if="!movAjtItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <i class="bx bx-camera-off"></i>
                        </div>
                      </div>

                      <div class="avatar-sm ms-auto" v-if="movAjtItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <img class="rounded-circle avatar-xs" :src="movAjtItemData.img1" alt />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 174px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <span class="text-muted mb-2">Código: </span> <span class="text-info">   {{ movAjtItemData.produto }} </span>
                    </div>
                    <div class="">
                      <p class="text-muted mb-2">Preço de Tabela (Bruto)</p>
                      <h5 class="mb-0 mt-3">R$ {{ formatDecimal(movAjtItemData.vlrunitbrt) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </router-link>



          <form class="needs-validation" @submit.prevent="confOrctoItem">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="vlrunitliq">Valor Unitário</label>
                  <input
                      id="vlrunitliq"
                      v-model="movAjtItemData.vlrunitliq"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor unitário líquido"
                      :class="{'is-invalid': submitOrctoItem && v$.movAjtItemData.vlrunitliq.$error,}"/>
                  <div v-if="submitOrctoItem && v$.movAjtItemData.vlrunitliq.$error"
                       class="invalid-feedback">
                    <span v-if="v$.movAjtItemData.vlrunitliq.required.$message">{{ v$.movAjtItemData.vlrunitliq.required.$message }}</span>
                  </div>
                </div>
              </div>


              <div class="col-md-6">
                <div class="mb-3">
                  <label for="qtd">Quantidade</label>
                  <input
                      id="qtd"
                      v-model="movAjtItemData.qtd"
                      type="number"
                      class="form-control text-end"
                      placeholder="Quantidade"
                      :class="{'is-invalid': submitOrctoItem && v$.movAjtItemData.qtd.$error,}"/>
                  <div v-if="submitOrctoItem && v$.movAjtItemData.qtd.$error"
                       class="invalid-feedback">
                    <span v-if="v$.movAjtItemData.qtd.required.$message">{{ v$.movAjtItemData.qtd.required.$message }}</span>
                  </div>
                </div>
              </div>

            </div>

          </form>

        <div class="table-responsive mt-2">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Movimentos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movajuste/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Maior movimento com esta origem (2 und):</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Desconto({{ formatDecimal(movAjtItemData.desconto) }}%):</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(movAjtItemData.vlrtotalbrt - movAjtItemData.vlrtotalliq) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Valor Total Líquido do Item:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(movAjtItemData.vlrtotalliq) }}</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>

      <div>
        <div class="row">
          <div class="text-start mt-5">
            <router-link  to="/produto/editar/0" target="_blank">
              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
              Cadastrar Novo Produto
            </router-link>
          </div>
        </div>
      </div>

      <div v-if="!loadingMovAjtItem && movAjtItemData && movAjtItemData.descprod">
        <div class="row">
          <div class="text-end mt-0">
            <b-button variant="light" @click="showModalMovAjtItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confOrctoItem">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>




    <b-modal title="Importar XML" v-model="showModalImpXML" centered hide-footer>
      <div class="col-md-12">
        <DropZone @drop.prevent="drop" @change="selectedFile"  />
        <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImpXML = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarXML">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size="md"
             title="Transferência de Produto"
             v-model="showModalEndereco" centered hide-footer>

      <div class="row col-sm-12">
        <div class="mb-1">
          <label for="novoendwms">Novo Endereço</label>

          <multiselect id="novoendwms"
                       @search-change="pesqEndereco"
                       v-model="wmsenderecoPadrao"
                       placeholder="Pesquisar endereços"
                       :options="dtlistPesqEndereco"
                       :searchable="true"
                       label="descricao"
                       ref="novoendwms"
                       track-by="descricao"
                       value-prop="descricao">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    Cód. empresa:
                    {{ slotProps.option.empresa }}
                  </span>
                  <span class="text-info">

                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.endereco }}({{ slotProps.option.codigo ?? slotProps.option.id }})
                  </span>
                </div>
                <div class="mt-2 ">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
              </div>
            </template>
          </multiselect>

          <div v-if="!wmsenderecoPadrao">
            <span class="text-danger font-size-11">Campo endereço obrigatório, favor preencher.</span>
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalEndereco = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>

        <b-button type="submit" variant="success" class="ms-1" @click="confirmar">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal size="md"
             :title="`Associação de Lote ao item (${movajtitemedit.produto})`"
             v-model="showModalLote" centered hide-footer>

      <div class="row col-sm-12">
        <div class="mb-1">
          <label for="novoLote">Lote ({{ movajtitemedit.descprod }})</label>
          <input
            v-model="movajtitemedit.lote"
            type="text"
            class="form-control"
            placeholder="Lote"
          />

          <div v-if="movajtitemedit.deflote">
            <span class="text-danger font-size-11">Lote obrigatório, favor preencher.</span>
          </div>
          <div v-else>
            <span class="text-success font-size-11">Lote opcional | não obrigatório, não é necessário preencher</span>
          </div>
        </div>
      </div>

      <br>

      <div class="col-md-6">
        <div class="mb-3">
          <div class="mb-2">
            <span class="text-black font-18 ">Endereço</span>
          </div>

          <multiselect id="endereco"
                       ref="endwms"
                       required
                       @search-change="pesqEndereco"
                       @select="escolheuEndereco"
                       v-model="movajtitemedit.endwms"
                       placeholder="Pesquisar endereços"
                       :options="dtlistPesqEndereco"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="descricao">
            <template #option="slotProps">
              <div class="row">
                <div>
                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                  <span class="mx-4" >
                              {{ slotProps.option.endereco }}
                            </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                            </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
              </div>
            </template>
          </multiselect>
          <div v-if="submitOrctoItem && !movAjtItemData.endwms">
            <span class="text-danger font-size-11">Campo endereço obrigatório, favor preencher.</span>
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalLote = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>

        <b-button type="submit" variant="success" class="ms-1" @click="confirmaAssocLote">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalErros"
        id="showModalErros"
        size="lg"
        title="Erros gerados na ação"
        title-class="font-18"
        hide-footer
        @hide="carregarDados"
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Erro</th>
                    <th>ID Produto</th>
                    <th>Código Produto</th>
                    <th>Nome Produto</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListErrors" :key="data.id">
                    <td>{{data.error}}</td>
                    <td>{{data.produto_id}}</td>
                    <td>{{data.produto_cod}}</td>
                    <td>{{data.produto_desc}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <br><br>
              <!--<div class="d-flex">
                <div>
                  <h6>Deseja criar um novo ajuste para alteração da quantidade?</h6>
                  <h6 class="text-danger">Nova quantidade de itens será a disponível em estoque!</h6>
                </div>
                <b-button type="submit" variant="success" class="mx-2" @click="criarNovoMovAjt">
                  <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                  Confirmar
                </b-button>
                <b-button type="submit" variant="danger" class="mx-2" @click="cancelaNovoAjt">
                  <i class="bx bx-x font-size-16 align-middle me-2"></i>
                  Cancelar
                </b-button>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>



<style>
.multiselect-size {
  --ms-max-height: 500px;
}
</style>

